import React, { ReactElement, ReactNode } from 'react';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import DeviceDetailsProviderContext from 'shared/providers/device-details/contexts/device-details-provider-context';
import { DeviceDetailsState, useDeviceDetailsState } from 'shared/providers/device-details/hooks/device-details-state';

const DeviceDetailsContext = React.createContext<DeviceDetailsState>({} as never);

type Props = {
  children: ReactNode;
  deviceId: string | undefined;
  initialViewingMode: ViewingMode;
};

export const DeviceDetailsProvider = ({ children, deviceId, initialViewingMode }: Readonly<Props>): ReactElement => {
  return (
    <DeviceDetailsProviderContext value={useDeviceDetailsState({ deviceId, initialViewingMode })}>{children}</DeviceDetailsProviderContext>
  );
};

export const useDeviceDetailsContextProvider = (): DeviceDetailsState => React.useContext<DeviceDetailsState>(DeviceDetailsContext);
